import {Tabs} from './tabs';

const initTabs = () => {
  const tabs = new Tabs();
  tabs.init();

  return tabs;
};

export {initTabs};
